if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.onKeyDownHandler = this.onKeyDownHandler.bind(this);
        document.addEventListener('keydown', this.onKeyDownHandler);
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.isProductPage = document.querySelector('.template-product');
      }

      checkQty(prodId, qty, maxQty) {
        let qtyMessage = window.cartStrings.maxLimitReached.replace('[quantity]', maxQty);
        const submitButton = this.querySelector('[type="submit"]');
        let isQtyLimited = () => {
          this.handleErrorMessage(qtyMessage);
          submitButton.setAttribute('disabled', true);
          submitButton.classList.add('qty-limited');
        }
        if (qty === maxQty) {
          isQtyLimited();
        }
        if (qty > maxQty) {
          disableGlobalCheckout();
          isQtyLimited();
        }
      }
      updateCartItems(prodId, qty) {
        for (const itemId in window.finalCartItems) {
          if (prodId in window.finalCartItems) {
            window.finalCartItems[prodId] = window.finalCartItems[prodId] + qty;
            return this.checkQty(prodId, window.finalCartItems[prodId], window.limitedQtyProducts[prodId]);
          }
        }
        if (!(prodId in window.finalCartItems)) {
          Object.assign(window.finalCartItems, { [prodId]: qty });
          this.checkQty(prodId, qty, window.limitedQtyProducts[prodId]);
        }
      }
      checkPurchaseLimit(prodId) {
        const isLoading = async () => {
          return document.readyState === "complete";
        }
        isLoading().then(r => {
          let
            isEmptyFinalCart = Object.keys(window.finalCartItems).length === 0,
            inputQty = parseInt(document.querySelector(`[data-quantity-inp="${prodId}"]`).value);
          this.checkQty(prodId, inputQty, window.limitedQtyProducts[prodId]);
          (!(isEmptyFinalCart)) ? this.updateCartItems(prodId, inputQty) : Object.assign(window.finalCartItems, { [prodId]: inputQty });
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        if (window.enable_purchase_limit && this.isProductPage) {
          let hasPurchaseLimitEnabled = this.parentNode.querySelector('.product-form__error-message-wrapper').hasAttribute('data-limit-message-wrapper');
          if (hasPurchaseLimitEnabled) {
            let
              prodId = parseInt(this.parentNode.querySelector('[data-limit-message-wrapper]').getAttribute('data-limit-message-wrapper')),
              maxQty = window.limitedQtyProducts[prodId],
              qty = parseInt(document.querySelector(`[data-quantity-inp="${prodId}"]`).value),
              arrQty = window.finalCartItems[prodId];
            qty += arrQty;
            if (qty > maxQty) {

              this.handleErrorMessage(`Quantity limit for this product is ${maxQty}. Please add a smaller value.`);
            }
            this.checkPurchaseLimit(prodId);
          }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        
        this.errorMessageWrapper && !this.errorMessageWrapper.hasAttribute('data-limit-message-wrapper') ? this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage) : '';

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const soldOutMessage = document.getElementById('out-of-stock-message');
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          if(soldOutMessage) soldOutMessage.removeAttribute("style");
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          if(soldOutMessage) soldOutMessage.style.display = "none";
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      onKeyDownHandler(event) {
        if (event.key !== 'Escape') return;

        const quickAddModal = this.closest('quick-add-modal');
        if (!quickAddModal) return;

        event.preventDefault();
        quickAddModal.hide(true);
      }
    }
  );
}
